import { Fragment } from 'react';
import RenderInfoLogic from '../../../../../components/InfoSidebar/RenderInfoLogic';

interface ManageGraphsProps {
  sectionTitle: any;
  tab: any;
  view: any;
  source: any;
  names: any;
  searchItems: any;
  title: any;
  Graph?: any;
  setSearchItems: any;
}

function ManageGraphs({ view, source, names, searchItems, Graph = null, setSearchItems }: ManageGraphsProps) {
  return (
    <Fragment>
      <div className="Cabtabla mt-3">
        {names && (
          <div className="row items-end justify-start md:justify-end mb-4 md:mb-0">
            <RenderInfoLogic
              searchItems={searchItems}
              selectedInfoItem={null}
              setSearchItems={setSearchItems}
              isMapping={false}
              showModalExample={false}
              setShowModalExample={() => {}}
              hideSearchItemsList
            />
          </div>
        )}
      </div>

      {Graph && <Graph source={source} view={view} names={names} setSearchItems={setSearchItems} />}
    </Fragment>
  );
}

export default ManageGraphs;
